import clsx from 'clsx'
import Flex from '@/components/atoms/Flex'
import Icon from '@/components/atoms/Icon'

import styles from './CustomNavigation.module.scss'

const CustomNavigation = ({
  handlePrev,
  handleNext,
}: {
  handlePrev: () => void
  handleNext: () => void
}) => (
  <Flex
    className='custom-navigation'
    alignItems='center'
    gap='16px'
  >
    <div
      className={clsx('prev-arrow', styles.arrow)}
      onClick={handlePrev}
    >
      <Icon iconName='ArrowLeft' />
    </div>
    <div
      className={clsx('next-arrow', styles.arrow)}
      onClick={handleNext}
    >
      <Icon iconName='ArrowRight' />
    </div>
  </Flex>
)

export default CustomNavigation
